<template>
  <div class="title-page-view">
    <img :src="titleImageBackground" alt="">
    <div class="title-content">
      <h2>{{titleObj.mainHeading}}</h2>
      <div><p></p></div>
      <h3>{{titleObj.subhead}}</h3>
      <p class="title">{{titleObj.content}}</p>
    </div>
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {}
    },
    props:{
      titleObj:Object,
      titleImageBackground:String
    },
    methods:{},
    mounted(){}
  }
</script>
<style lang="scss" rel="stylesheet" scoped="">
  .title-page-view{
    width:100%;
    position: relative;
    img{
      width:100%;
    }
    .title-content{
      width:7rem;
      position: absolute;
      top:50%;left:50%;
      transform: translate(-50%, -50%);
      h2{
        color:#ffffff;
        font-size:0.48rem;
      }
      h3{
        color:#dee1e3;
        font-size:0.22rem;
      }
      div{
        width:1.9rem;
        height:1px;
        background:#d5d5d5;
        margin:0.1rem auto;
        p{
          width:0.5rem;
          height: 2px;
          background:#ffbd1f;
          margin:auto;
          position: relative;
          top:-1px;
        }
      }
      .title{
        color:#f8f9f9;
        font-size:0.22rem;
        margin-top:0.1rem;
      }
    }
  }
</style>
